<template src="./index.html">
</template>
<script>
export default {
  name: '',
  components: {
  },
  data: function() {
    return {
		headdata:[
			{
				name:"添加文件",
			},
			{
				name:"科目映射",
			},
			{
				name:"上传结果",
			}
		],
    };
  },
  props: {
  	uptype: {
  		type: Number, 
  		default: 1
  	},
  },
  created() {
  },
  methods: {
  }
};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
